import { useQuery } from '@tanstack/react-query';
import { QUERY_CACHE_CONFIG } from 'configs/queryCache';
import {
  BidvBankTransferService,
  DomesticBankListH2hEntity,
} from 'services/openapi';

import { BidvBankTransferServiceKeys } from './constants';

type ListDomesticBanksVariables = {
  code?: string;
  transferMethod?: 'I' | 'O' | 'F';
  page?: number;
  limit?: number;
};

export const useListBidvDomesticBanksQuery = (
  variables: ListDomesticBanksVariables = {},
) => {
  const { code, transferMethod, page = 1, limit = 20 } = variables;
  const queryKey = [BidvBankTransferServiceKeys.LIST_DOMESTIC_BANKS, variables];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<DomesticBankListH2hEntity, Error>({
    queryKey,
    queryFn: () =>
      BidvBankTransferService.bidvBankTransferControllerListDomesticBanks(
        code,
        transferMethod,
        page,
        limit,
      ),
    ...QUERY_CACHE_CONFIG.REFERENCE_DATA,
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled: true,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data,
    isError,
    queryKey,
    refetch,
  };
};
